/**
 * Direct database access for emergency fixes
 * This is not meant to be used in normal operation and should be removed after fixing issues
 */
import { apiRequest } from "./queryClient";

interface DirectQueryResult {
  success: boolean;
  data?: any;
  error?: string;
}

export async function execute(query: string, params: any[] = []): Promise<DirectQueryResult> {
  try {
    const response = await apiRequest("POST", "/api/db-direct", {
      query,
      params
    });
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    const result = await response.json();
    return {
      success: true,
      data: result
    };
  } catch (error) {
    console.error("Direct DB execute error:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error"
    };
  }
}

export async function getTimezone(businessId: number): Promise<string> {
  try {
    // First try the API endpoint
    const response = await fetch(`/api/businesses/${businessId}/direct-timezone`, {
      credentials: 'include'
    });
    
    if (response.ok) {
      const data = await response.json();
      if (data && data.timezone) {
        return data.timezone;
      }
    }
    
    // If the API fails, try a direct lookup
    const result = await execute(
      "SELECT timezone FROM businesses WHERE id = $1",
      [businessId]
    );
    
    if (result.success && result.data && result.data.rows && result.data.rows.length > 0) {
      return result.data.rows[0].timezone || "America/New_York";
    }
    
    // Default fallback
    return "America/New_York";
  } catch (error) {
    console.error("Error retrieving timezone:", error);
    return "America/New_York";
  }
}

export async function updateTimezone(businessId: number, timezone: string): Promise<boolean> {
  try {
    // Try the API first
    const response = await apiRequest("PATCH", `/api/businesses/${businessId}/timezone`, {
      timezone
    });
    
    if (response.ok) {
      return true;
    }
    
    // If API fails, try direct update
    const result = await execute(
      "UPDATE businesses SET timezone = $1 WHERE id = $2",
      [timezone, businessId]
    );
    
    return result.success;
  } catch (error) {
    console.error("Error updating timezone:", error);
    return false;
  }
}